import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GoogleCallbackHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");

    const token = localStorage.getItem("access_token");

    if (code && token) {
      fetch(`http://localhost:8000/api/google-drive/callback/?code=${code}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      })
        .then(res => res.json())
        .then(data => {
          localStorage.setItem("drive_connected", "true");

          // Redirect back to the account tab (drive)
          navigate("/account/integration");
        })
        .catch(err => {
          console.error("Google Drive connection failed", err);
        });
    }
  }, []);

  return <div className="p-4 text-gray-700">Connecting your Google Drive...</div>;
};

export default GoogleCallbackHandler;